<h2 class="layout-title">{{ 'USER.CHANGE_PASSWORD.TITLE' | transloco }}</h2>
<div class="card">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" *transloco="let t; read: 'USER.CHANGE_PASSWORD.FORM'">
    <div class="col-12 mb-2 lg:mb-0">
      <div class="p-inputgroup">
        <input
          class="w-full"
          [type]="showPassword ? 'text' : 'password'"
          [placeholder]="t('CONTROL.OLD_PASSWORD')"
          pInputText
          [formControl]="oldPasswordControl"
        />
        <span class="p-inputgroup-addon p-0"
          ><button
            pButton
            pRipple
            type="button"
            [icon]="'pi ' + (showPassword ? 'pi-eye-slash' : 'pi-eye')"
            class="p-button-sm p-button-text"
            (click)="showPassword = !showPassword"
            tabindex="-1"
          ></button
        ></span>
      </div>
      <ngx-form-error [control]="oldPasswordControl"></ngx-form-error>
    </div>
    <div class="col-12 mb-2 lg:mb-0">
      <div class="p-inputgroup">
        <input
          class="w-full"
          [type]="showPassword ? 'text' : 'password'"
          [placeholder]="t('CONTROL.NEW_PASSWORD1')"
          pInputText
          [formControl]="newPassword1Control"
        />
        <span class="p-inputgroup-addon p-0"
          ><button
            pButton
            pRipple
            type="button"
            [icon]="'pi ' + (showPassword ? 'pi-eye-slash' : 'pi-eye')"
            class="p-button-sm p-button-text"
            (click)="showPassword = !showPassword"
            tabindex="-1"
          ></button
        ></span>
      </div>
      <ngx-form-error [control]="newPassword1Control"></ngx-form-error>
    </div>
    <div class="col-12 mb-2 lg:mb-0">
      <div class="p-inputgroup">
        <input
          class="w-full"
          [type]="showPassword ? 'text' : 'password'"
          [placeholder]="t('CONTROL.NEW_PASSWORD2.PLACEHOLDER')"
          pInputText
          [formControl]="newPassword2Control"
        />
        <span class="p-inputgroup-addon p-0"
          ><button
            pButton
            pRipple
            type="button"
            [icon]="'pi ' + (showPassword ? 'pi-eye-slash' : 'pi-eye')"
            class="p-button-sm p-button-text"
            (click)="showPassword = !showPassword"
            tabindex="-1"
          ></button
        ></span>
      </div>
      <ngx-form-error [control]="newPassword2Control"></ngx-form-error>
    </div>
    <div class="col-12 mt-2 text-right"
      ><button type="submit" pButton class="p-button-rounded" [label]="t('SUBMIT')"></button
    ></div>
  </form>
</div>
<p-toast key="change-password"></p-toast>
